import "core-js/modules/es6.array.map.js";
import React from 'react';
import flattenChildren from 'react-keyed-flatten-children';
import { useDeprecatedClassNameStylePropsWarning } from '../../internal/deprecated-classname-style-props';
import { Box } from '../Box/Box';
import { Divider } from '../Divider/Divider';
export var Stack = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 3 : _ref$spacing,
      className = _ref.className,
      dividers = _ref.dividers,
      children = _ref.children;
  var flattenedChildren = flattenChildren(children);
  useDeprecatedClassNameStylePropsWarning('Stack', {
    className: className
  });
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    ref: ref,
    "data-currency": "Stack"
  }, flattenedChildren.map(function (child, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      // Default to child.key to enable users to opt in to keyed
      // children. Since the `React.ReactChild` type includes the
      // `string` type, we need to cast the child to `any` to avoid a
      // TypeScript error.
      key: child.key || index
    }, /*#__PURE__*/React.createElement(Box, {
      marginBottom: index !== flattenedChildren.length - 1 ? spacing : undefined,
      marginTop: index !== 0 ? spacing : undefined
    }, child), dividers && index !== flattenedChildren.length - 1 && /*#__PURE__*/React.createElement(Divider, {
      level: dividers
    }));
  }));
});
Stack.displayName = 'Stack';